import { ListFilter } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface SearchCappedNoticeProps {
  /**
   * Счёт совпадений неполон: показанное число — нижняя граница (#930).
   *
   * Приходит с сервера (`searchTotalIsPartial`). Поиск идёт в два шага, и
   * когда страница набралась раньше, чем кончились совпадения, сосчитано
   * только просмотренное.
   */
  partial: boolean;
  /** Сколько совпадений насчитано на просмотренном. */
  total: number;
  className?: string;
}

/**
 * Пометка «совпадений не меньше N» (#820, уточнена в #930).
 *
 * Рядом с выдачей, а не тостом: описывает то, что сейчас на экране, и живёт
 * ровно столько же, сколько эта выдача. Соседка — `SearchTruncatedNotice`.
 */
export function SearchCappedNotice({
  partial,
  total,
  className = '',
}: SearchCappedNoticeProps) {
  const { t } = useTranslation('common');

  if (!partial) return null;

  return (
    <div
      data-testid="search-capped-notice"
      role="status"
      className={`flex items-start gap-1.5 text-xs text-warning ${className}`}
    >
      <ListFilter className="h-3.5 w-3.5 shrink-0 mt-px" aria-hidden="true" />
      {/* Переменная `total`, а не `count`: `count` включает у i18next разбор
          множественного числа, и ключу понадобились бы формы `_one/_few/_many`
          в каждой локали ради строки, где число всегда в одном падеже. */}
      <span>{t('common.searchTotalPartial', { total })}</span>
    </div>
  );
}
